// extracted by mini-css-extract-plugin
export var filterButton = "_lg-1";
export var filtersContainer = "_lg-0";